import React from 'react';
import { Phone, ClipboardList } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Link } from 'react-router-dom';
import { businessInfo } from '../mockData';
import { TrustStrip } from '../components/TrustStrip';
import { IntroSection } from '../components/IntroSection';
import { ServicesSection } from '../components/ServicesSection';
import { WhyChooseUsSection } from '../components/WhyChooseUsSection';
import { GallerySection } from '../components/GallerySection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { FAQSection } from '../components/FAQSection';
import { FinalCTASection } from '../components/FinalCTASection';
import { ContactSection } from '../components/ContactSection';
import { RoofQuiz } from '../components/RoofQuiz';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../components/ui/dialog';
import { ImageSlideshow } from '../components/ImageSlideshow';

export const HomePage = () => {
  const [isQuizOpen, setIsQuizOpen] = React.useState(false);

  return (
    <div>
      {/* Hero Section */}
      <section id="home" className="relative min-h-screen flex items-center pt-20">
        {/* Background Image Slideshow with Overlay */}
        <div className="absolute inset-0 z-0">
          <ImageSlideshow />
          <div className="absolute inset-0 bg-gradient-to-r from-black/95 via-black/85 to-black/70"></div>
        </div>

        {/* Content */}
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-3xl">
            <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-white mb-6 leading-tight animate-fade-in-up">
              Metal Roofing Specialists
              <span className="block text-primary mt-2">in Greater Sydney</span>
            </h1>

            <p className="text-lg sm:text-xl text-gray-200 mb-8 leading-relaxed animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
              Dezire Metal Roofing provides professional metal roof installation, roof replacement, repairs, and guttering services across Greater Sydney. We focus on quality workmanship, reliable service, and roofing solutions built to last in Australian conditions.
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 animate-fade-in-up" style={{ animationDelay: '0.3s' }}>
              <Link to="/book-inspection" className="w-full sm:w-auto">
                <Button
                  size="lg"
                  className="bg-primary hover:bg-accent text-white text-base sm:text-lg px-6 sm:px-8 py-5 sm:py-6 shadow-lg hover:shadow-xl w-full"
                  data-testid="hero-book-inspection-btn"
                >
                  <ClipboardList className="w-5 h-5 mr-2" />
                  Book a Free Inspection
                </Button>
              </Link>
              <a href="/call" className="w-full sm:w-auto">
                <Button
                  size="lg"
                  className="bg-white text-gray-900 hover:bg-gray-100 text-base sm:text-lg px-6 sm:px-8 py-5 sm:py-6 w-full"
                  data-testid="hero-call-btn"
                >
                  <Phone className="w-5 h-5 mr-2" />
                  Call 0433 973 844
                </Button>
              </a>
            </div>

            {/* Trust Line */}
            <div className="mt-8 animate-fade-in-up" style={{ animationDelay: '0.4s' }}>
              <p className="text-gray-300 text-base sm:text-lg">
                Free quotes <span className="text-primary mx-2">|</span> Fast response <span className="text-primary mx-2">|</span> Greater Sydney service area
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Homepage Sections in Priority 2 Order:
          1. Hero (above)
          2. Trust strip
          3. Intro section
          4. Services
          5. Why choose us
          6. Gallery / recent work
          7. Testimonials
          8. FAQ
          9. Final call to action
          10. Contact details
      */}
      <TrustStrip />
      <IntroSection />
      <ServicesSection />
      <WhyChooseUsSection />
      <GallerySection />
      <TestimonialsSection />
      <FAQSection />
      <FinalCTASection />
      <ContactSection />

      {/* Quiz Dialog */}
      <Dialog open={isQuizOpen} onOpenChange={setIsQuizOpen}>
        <DialogContent className="max-w-3xl max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="sr-only">Free Roof Assessment Quiz</DialogTitle>
          </DialogHeader>
          <RoofQuiz onClose={() => setIsQuizOpen(false)} />
        </DialogContent>
      </Dialog>
    </div>
  );
};
